export const tileManagerFileListConfig: any[] = [
    {
        title: 'FileName',
        field: 'filename',
    },
    {
        title: 'Type',
        field: 'type',
    },
    {
        title: 'Path',
        field: 'filePath',
    },
];
